import * as React from 'react';
import { useRef } from 'react';
import { getScrollStatusVertical } from '../common.js';

const isBrowser = typeof window !== `undefined`;
const useScrollStatusVertical = (ref, effect, deps, wait = 80) => {
  const position = useRef(ref.current ? getScrollStatusVertical(ref.current) : null);
  let throttleTimeout = null;
  const run = () => {
    if (!ref.current || !effect) {
      return;
    }
    const currPos = getScrollStatusVertical(ref.current);
    if (currPos !== position.current) {
      effect(currPos);
      position.current = currPos;
    }
    throttleTimeout = null;
  };
  React.useLayoutEffect(() => {
    if (!isBrowser || !effect || !ref.current) {
      return void 0;
    }
    const handle = ref.current;
    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = window.setTimeout(run, wait);
        }
      } else {
        run();
      }
    };
    ref.current.addEventListener("load", handleScroll, { passive: true, once: true });
    ref.current.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      handle?.removeEventListener("scroll", handleScroll);
      if (throttleTimeout) {
        clearTimeout(throttleTimeout);
      }
    };
  }, [deps, run, wait]);
};

export { useScrollStatusVertical };
